import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16 md:mt-24">
      <div className="px-4 md:px-6 py-10 md:py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center font-heading font-extrabold text-lg text-background-50">
              黑
            </span>
            <span className="font-heading font-extrabold text-xl text-background-50">黑料</span>
          </div>
          <p className="text-sm text-background-200/80 leading-relaxed max-w-md">
            黑料致力于为你追踪最新娱乐八卦、明星隐秘消息与社会热点揭秘，覆盖影视、综艺、娱乐新闻等多个领域，让你第一时间了解最新内幕动态。
          </p>
          <div className="flex items-center gap-3 mt-5">
            <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition">
              <i className="ri-wechat-line" />
            </span>
            <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition">
              <i className="ri-weibo-line" />
            </span>
            <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition">
              <i className="ri-qq-line" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm text-background-50 mb-4">内容分类</h4>
          <ul className="space-y-2.5 text-sm">
            {categories.map((item) => (
              <li key={item.slug}>
                <Link
                  to={`/category/${item.slug}`}
                  className="text-background-200/80 hover:text-primary-300 transition cursor-pointer"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm text-background-50 mb-4">关于本站</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-background-200/80 hover:text-primary-300 transition cursor-pointer">
                网站介绍
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-200/80 hover:text-primary-300 transition cursor-pointer">
                爆料投稿
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-200/80 hover:text-primary-300 transition cursor-pointer">
                免责声明
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-background-200/80 hover:text-primary-300 transition cursor-pointer">
                站内搜索
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-300/70">
        <p>© 2026 黑料 HeiLiao · 保留所有权利</p>
        <p>本站内容均为虚构演示素材，仅供产品展示，请勿对号入座。</p>
      </div>
    </footer>
  );
}